import {APIEventSystem} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {ISymbol, SimpleReelModelEventData, SimpleReelModelState} from "../../core/reel/IReelData";
import {ReelView} from "./ReelView";
import {ReelSet} from "../server/ReelSet";
import {gsap, TimelineLite} from "gsap";
import {HOTB} from "../HOTB";

export class AvalancheReelModel {
    /**
     * Triggers on: ReelStateChange and each ReelModelState
     */
    public readonly events: APIEventSystem | undefined;
    public readonly id: number;
    private _reelSetIndex: number = 0;
    private _spinning: boolean = false;
    private _masterSpinTimeline: TimelineLite | undefined;
    private readonly _reelId: number;
    private readonly _reelView: ReelView;

    constructor(id: number, triggerEvents: boolean = true) {
        this._reelId = id;
        this._reelView = new ReelView(id);
        if (triggerEvents) {
            this.events = HOTB.apiPlugin.eventSystemFactory.create();
            this.events.on("ReelStateChange", (data: SimpleReelModelEventData) => this.onReelStateChange(data)); //To prevent event system from saving once callbacks if no on callbacks is set.
        }
    }

    private _state: SimpleReelModelState = SimpleReelModelState.IDLE;

    set state(value: SimpleReelModelState) {
        this._state = value;
        if (this.events) {
            this.events.trigger("ReelStateChange", <SimpleReelModelEventData>{reel: this.reelId, state: this._state});
        }
    }

    get reelId(): number {
        return this._reelId;
    }

    get reelView(): ReelView {
        return this._reelView;
    }

    private _reelSet: string[] | undefined;
    get reelSet(): string[] {
        if (!this._reelSet) {
            throw new Error(`No reelset set for reel: ${this.reelId}`);
        }
        return this._reelSet;
    }

    public init(symbols: string[]): void {
        this.setReelSet(ReelSet.DEFAULT_REEL_SET[this._reelId]);
        if(HOTB.model.isActionSpinToBonus){
            this._reelView.reInitReel(symbols);    
        }else{
            this._reelView.initReel(symbols);
        }
    }

    public setReelSet(reelSet: string[], index?: number): void {
        this._reelSet = reelSet;
        index = index != undefined ? index : Math.floor(Math.random() * this._reelSet.length);
        this.setReelIndex(index);
    }

    /**
     * Adding bounce on reel spin start
     */
    public start(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add((): void => {
            this.state = SimpleReelModelState.START
        });
        tl.add(() => this.startSpin());
        return tl;
    }

    public stop(reelData: string[]): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete: (): void => {
                this.state = SimpleReelModelState.STOPPED;
                this.state = SimpleReelModelState.IDLE;
            }
        });
        tl.add(this._reelView.stop(reelData));
        return tl;
    }

    public getSymbol(position: number): ISymbol {
        return this._reelView.getSymbol(position);
    }

    private setReelIndex(value: number): void {
        if (value >= this.reelSet.length) {
            value = 0;
        } else if (value < 0) {
            value = this.reelSet.length - 1;
        }
        this._reelSetIndex = value;
    }

    /**
     * Starting the actual spin by adding it to the masterSpinTimeline
     * @private
     */
    private startSpin(): void {
        this._spinning = true;
        this.state = SimpleReelModelState.SPIN;
        this._masterSpinTimeline = new TimelineLite();
        this._masterSpinTimeline.add(this.spin());
    }

    private spin(): TimelineLite {
        const timeline: TimelineLite = new TimelineLite();
        timeline.add((): void => {
            this._reelView.getAllOutAnimation()
        });
        timeline.add(() => this.onSpinStartedCompleted());
        return timeline;
    }

    private onSpinStartedCompleted(): void {
        // todo in case anything needs to be done on spin start completed
    }

    private onReelStateChange(data: SimpleReelModelEventData): void {
        this.events?.trigger(data.state, data);
    }
}